// Django UserAttributeSimilarityValidator uses SequenceMatcher.quick_ratio()
// (the multiset overlap), a 0.7 threshold, and each word plus the full attribute.
// https://github.com/django/django/blob/stable/5.2.x/django/contrib/auth/password_validation.py
export function isPasswordSimilar(password: string, attributes: readonly string[]): boolean {
  const characters = Array.from(password.toLowerCase());
  if (!characters.length) return false;
  const counts = new Map<string, number>();
  for (const character of characters) counts.set(character, (counts.get(character) ?? 0) + 1);

  return attributes.some(attribute => {
    if (typeof attribute !== 'string' || !attribute.trim()) return false;
    const value = attribute.toLowerCase();
    return [...value.split(/[^\p{L}\p{N}_]+/u), value].some(part => {
      const other = Array.from(part);
      if (!other.length || (2 * Math.min(characters.length, other.length)) / (characters.length + other.length) < 0.7) {
        return false;
      }
      const available = new Map(counts);
      let matches = 0;
      for (const character of other) {
        const remaining = available.get(character) ?? 0;
        if (remaining > 0) {
          matches++;
          available.set(character, remaining - 1);
        }
      }
      return (2 * matches) / (characters.length + other.length) >= 0.7;
    });
  });
}
